import { StethoscopeIcon } from "assets/icons/Stethoscope";

import { StyledNoServices } from "./styled";

export function NoServices() {
  return (
    <StyledNoServices
      data-testid="noServices"
      className="flex flex-column align-items-center justify-content-center gap-2 py-6 px-4"
    >
      <div
        className="flex align-items-center justify-content-center border-circle"
        style={{
          width: "3rem",
          height: "3rem",
          background: "var(--brand-blue-25)",
          color: "var(--brand-purple-700)",
        }}
      >
        <StethoscopeIcon width={22} height={22} />
      </div>

      <span
        className="text-base font-semibold line-height-2"
        style={{ color: "var(--brand-black)" }}
      >
        No services added yet
      </span>

      <span
        className="text-sm line-height-2"
        style={{ color: "var(--brand-gray-600)" }}
      >
        Search above to add a CPT code.
      </span>
    </StyledNoServices>
  );
}
